// extracted by mini-css-extract-plugin
export default {"chip":"VhEu0UsPFwN0Sf8DmHiT","value":"XCpEAhffux8go1RY0RUK","fade":"_ciGLmv3Ibe60fJhjeso"};